(function initAccountSelection(global) {
  const normalizeCode = (value) => String(value?.code || value?.accountNumber || value?.nr || value?.accountCode || value?.value || value || '').trim();
  const normalizeText = (value) => String(value || '').trim().toLocaleLowerCase('nb-NO');
  const uniqueCodes = (values) => [...new Set((Array.isArray(values) ? values : []).map(normalizeCode).filter(Boolean))];

  const volatileFavorites = {};
  const persistenceVersions = {};
  const activeBusinessId = () => String(global.PlummeBackend?.activeBusinessId || 'local').trim() || 'local';
  const favoriteCodes = () => {
    const businessId = activeBusinessId();
    if (Array.isArray(volatileFavorites[businessId])) return uniqueCodes(volatileFavorites[businessId]);
    const stored = global.PlummeBackend?.userProfile?.preferences?.accountFavoritesByBusiness?.[businessId];
    return uniqueCodes(stored);
  };

  const wildcardPrefix = (query) => {
    const match = normalizeText(query).replace(/\s+/g, '').match(/^(\d+)[x*]+$/i);
    return match?.[1] || '';
  };

  const matchesQuery = (account, query, fields = []) => {
    const needle = normalizeText(query);
    if (!needle) return true;
    const code = normalizeCode(account);
    const prefix = wildcardPrefix(needle);
    if (prefix) return code.startsWith(prefix);
    const values = [code, account?.name, account?.label, account?.counterpartyNumber, ...(account?.keywords || []), ...fields];
    return values.map(normalizeText).some((value) => value.includes(needle));
  };

  const filterAccounts = (accounts, { mode = 'relevant', relevant = [], favorites = favoriteCodes(), query = '' } = {}) => {
    const source = Array.isArray(accounts) ? accounts : [];
    const favoriteSet = new Set(uniqueCodes(favorites));
    const relevantCodes = new Set((Array.isArray(relevant) ? relevant : []).map(normalizeCode).filter(Boolean));
    let base = source;
    if (mode === 'favorites') base = source.filter((account) => favoriteSet.has(normalizeCode(account)));
    else if (!normalizeText(query) && mode === 'relevant') base = source.filter((account) => relevantCodes.has(normalizeCode(account)));
    return base.filter((account) => matchesQuery(account, query));
  };

  const toggleFavorite = (code) => {
    const normalized = normalizeCode(code);
    if (!normalized) return favoriteCodes();
    const backend = global.PlummeBackend;
    const current = favoriteCodes();
    const exists = current.includes(normalized);
    const next = exists ? current.filter((entry) => entry !== normalized) : [...current, normalized];
    const businessId = activeBusinessId();
    volatileFavorites[businessId] = next;
    persistenceVersions[businessId] = (persistenceVersions[businessId] || 0) + 1;
    const persistenceVersion = persistenceVersions[businessId];
    const currentMap = backend?.userProfile?.preferences?.accountFavoritesByBusiness || {};
    const persistence = backend?.updateUserPreferencePatch?.({ accountFavoritesByBusiness: { ...currentMap, [businessId]: next } });
    if (persistence?.then) persistence.then(() => {
      if (persistenceVersions[businessId] === persistenceVersion) delete volatileFavorites[businessId];
    }).catch(() => {});
    global.dispatchEvent?.(new CustomEvent('plumme-account-favorites-changed', { detail: { businessId, codes: next } }));
    return next;
  };

  global.PlummeAccountSelection = {
    normalizeCode,
    favoriteCodes,
    wildcardPrefix,
    matchesQuery,
    filterAccounts,
    toggleFavorite,
  };
})(typeof window !== 'undefined' ? window : globalThis);
